import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '@modules/main/main.component';
import { LoginComponent } from '@modules/login/login.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { MediaManagementComponent } from '@pages/media-management/media-management.component';
import { AuctionCarinfoComponent } from '@pages/auction-carinfo/auction-carinfo.component';
import { AuctionCarListComponent } from '@pages/auction-car-list/auction-car-list.component';
import { ReportsComponent } from '@pages/reports/reports.component';
import { CustomerRequestComponent } from '@pages/customer-request/customer-request.component';
import { PurchaseDetailsComponent } from '@pages/purchase-details/purchase-details.component';
const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [NonAuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NonAuthGuard] },
  { path: 'recover-password', component: RecoverPasswordComponent, canActivate: [NonAuthGuard] },
  {
    path: 'dashboard',
    component: MainComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'inventory', loadChildren: () => import('./pages/inventory/inventory.module').then((module) => module.InventoryModule) },
      { path: 'auction', loadChildren: () => import('./pages/auction/auction.module').then((module) => module.AuctionModule) },
      { path: 'buyers', loadChildren: () => import('./pages/buyers/buyers.module').then((module) => module.BuyersModule) },
      { path: 'calendar', loadChildren: () => import('./pages/calendar/calendar.module').then((module) => module.CalendarModule) },
      { path: 'user', loadChildren: () => import('./pages/user/user.module').then((module) => module.UserModule) },
      { path: 'settings', loadChildren: () => import('./pages/settings/settings.module').then((module) => module.SettingsModule) },
      { path: 'cms', loadChildren: () => import('./pages/cms/cms.module').then((module) => module.CMSModule) },
      { path: 'comments', loadChildren: () => import('./pages/comments/comments.module').then((module) => module.CommentsModule) },
      { path: 'customer-request', component: CustomerRequestComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'media-management', component: MediaManagementComponent },
      { path: 'auction-details/:auctionId', component: AuctionCarinfoComponent },
      { path: 'purchase-details/:paymentId', component: PurchaseDetailsComponent },
      { path: 'auction-carlist', component: AuctionCarListComponent },
    ],
  },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    relativeLinkResolution: 'legacy',
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
